module.exports = __webpack_public_path__ + "img/matrix-wechat-mini.8550e95a.jpg";